import * as React from "react";

export type CollapsibleChildren = (className: string | undefined, ref: React.RefCallback<HTMLElement>) => JSX.Element;

export interface PropsToChildrenProps {
    className?: string | undefined;
    children: CollapsibleChildren;
}

export const PropsToChildren = React.forwardRef((props: PropsToChildrenProps, ref: React.ForwardedRef<HTMLElement>) => (
    <>
        {props.children(props.className, (element: HTMLElement | null) => {
            if (typeof ref === "function") {
                ref(element);
            } else if (ref != undefined) {
                ref.current = element;
            }
        })}
    </>
));
PropsToChildren.displayName = "PropsToChildren";
